export default __webpack_public_path__ + "static/media/thumb_up.000033b0.svg";